import { ApplicationInsights } from '@microsoft/applicationinsights-web'
import { ReactPlugin, withAITracking } from '@microsoft/applicationinsights-react-js'

export const reactPlugin = new ReactPlugin()

let ai = null

export const initAppInsights = instrumentationKey => {
    const ai = new ApplicationInsights({
        config: {
            instrumentationKey,
            extensions: [reactPlugin],
        },
    })

    ai.loadAppInsights()
}

export const getAppInsights = () => {
    return ai.appInsights
}

const withAppInsights = (Component, componentName, className) =>
    withAITracking(reactPlugin, Component, componentName, className)
export default withAppInsights
